<script setup lang="ts">
import { Button } from '~ds/components/ui/button';
import { Heading, Text } from '~ds/components/ui/typography';
import KUIUnifiedBlinky from '~kui/components/KUI/Unified/Blinky/KUIUnifiedBlinky.vue';
import { useI18n } from 'vue-i18n';

interface Props {
  /** The title's level: `h1` where the not-found is the whole page, `h2` inside one. */
  headingAs?: 'h1' | 'h2';
}

withDefaults(defineProps<Props>(), {
  headingAs: 'h2',
});

defineEmits<{
  back: [];
}>();

const { t } = useI18n();
</script>

<template>
  <div class="flex h-full w-full flex-col items-center justify-center gap-6 p-8 text-center">
    <KUIUnifiedBlinky
      gaze="darting"
      size="2xl"
    />

    <div class="flex flex-col gap-2">
      <Heading size="lg" :as="headingAs">
        {{ t('unified.activity.notFound.heading') }}
      </Heading>

      <Text size="md" class="text-foreground">
        {{ t('unified.activity.notFound.description') }}
      </Text>
    </div>

    <Button
      variant="secondary"
      size="default"
      type="button"
      @click="$emit('back')"
    >
      {{ t('unified.activity.notFound.goBack') }}
    </Button>
  </div>
</template>
